  export enum UserInfoStoreError {
    GET_USER_INFO = "Error fetching user information",
    GET_CURRENT_USER_INFO = "Error fetching user information",
    GET_ALL_NOTIFICATION_GROUPS = "Error fetching available Notification Groups",
    GET_USER_NOTIFICATION_GROUPS = "Error retrieving Notification Groups",
    GET_USER_NOTIFICATION_PREFS = "Error retrieving Notification Preferences",
    UPDATE_USER_NOTIFICATION_PREFS = "Error updating Notification Preferences for User",
    UPDATE_USER_PROFILE = "Error updating Profile for User",
    GET_USER_PREFERENCES = "Error getting preferences for User",
    UPDATE_USER_PREFERENCES = "Error saving preferences for User",
  }
  
  export enum UserInfoStoreSuccess {
    UPDATE_USER_NOTIFICATION_PREFS = "Successfully update user's notification preferences",
    UPDATE_USER_PROFILE = "Successfully updated user's Profile",
  }
  